import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useCotizacion from 'src/hooks/useCotizacion';
import useCustomToast from 'src/hooks/useCustomToast';
import { RootReducerType } from '..';
import { aceptarTerminosAction, setLoadingAction } from './actions';
import { defaultLoadingState, LoadingStateType } from './reducers';

const usePaginaPago = () => {
  const state = useSelector((state: RootReducerType) => state.PaginaPago);
  const { cotizacion } = useCotizacion();
  const dispatch = useDispatch();
  const { addWarningToast } = useCustomToast();

  const setDataPagos = useCallback(
    (payload: LoadingStateType) => {
      dispatch(setLoadingAction(payload));
    },
    [dispatch],
  );

  const aceptarTerminos = useCallback(
    (payload: boolean) => {
      dispatch(aceptarTerminosAction(payload));
    },
    [dispatch],
  );

  const setLoading = useCallback(
    (payload: LoadingStateType) => {
      dispatch(setLoadingAction(payload));
    },
    [dispatch],
  );

  const resetLoading = useCallback(
    (payload: LoadingStateType = defaultLoadingState) => {
      dispatch(setLoadingAction({ ...defaultLoadingState, ...payload }));
    },
    [dispatch],
  );

  const valdiarTerminos = useCallback(
    (callback: CallableFunction) => () => {
      if (cotizacion.tieneTerminosCondiciones) {
        //if (true) {
        if (state.terminosAceptados) {
          //if (false) {
          return callback();
        } else {
          return addWarningToast('Para continuar primero debe aceptar los términos y codiciones');
        }
      } else {
        return callback();
      }
    },
    [addWarningToast, cotizacion.tieneTerminosCondiciones, state.terminosAceptados],
  );

  return { ...state, aceptarTerminos, setLoading, resetLoading, valdiarTerminos };
};

export default usePaginaPago;
